/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * A directive that updates the error message and styles for a single input.
 * DO LATER : add unit/integration tests for this directive.
 */
angular.module('bulbApp.validationModule')
  .directive('bulbValidationField', ['$compile', '$q', '$timeout', '$translate', 'BulbBrowserService', 'BulbAjaxService', bulbValidationField]);

function bulbValidationField($compile, $q, $timeout, $translate, BulbBrowserService, BulbAjaxService) {
  return {
    restrict: 'A',
    scope: true,
    require: ['ngModel', '^form'],
    link(scope, elem, attrs, ctrls) {
      const model = ctrls[0];
      const form = ctrls[1];

      scope.errorMessage = '';
      scope.model = model;

      model.errorCodes = model.errorCodes || {};

      let $errorIconHTML = '';
      let $errorMessageHTML = '';

      // Default tooltip options:
      let tooltipOptions = {
        nubOffset: 34,
        tooltipClass: 'error-tooltip-override',
        iconClass: 'error-icon-tooltip',
        topPos: 0,
      };

      let errorMessageAlignment = {};

      // added the attributes to the form fields for the screen readers
      elem.attr('aria-invalid', false);
      elem.attr('aria-describedby', `${attrs.id}-validation-error-label`);

      // Override defaults with any overrides specified at the form level
      const formElement = elem.closest('form');
      if (formElement.attr('bulb-error-tooltip-overrides')) {
        tooltipOptions = Object.assign(tooltipOptions, scope.$eval(formElement.attr('bulb-error-tooltip-overrides')));
      }

      // Finally, override options with any overrides specified at the control level
      if (attrs.bulbErrorTooltipOverrides) {
        tooltipOptions = Object.assign(tooltipOptions, scope.$eval(attrs.bulbErrorTooltipOverrides));
      }

      if (formElement.attr('bulb-error-message-overrides')) {
        errorMessageAlignment = Object
          .assign(errorMessageAlignment, scope.$eval(formElement.attr('bulb-error-message-overrides')));
      }

      if (attrs.bulbErrorMessageOverrides) {
        errorMessageAlignment = Object.assign(errorMessageAlignment, scope.$eval(attrs.bulbErrorMessageOverrides));
      }

      let errorMessageAbove = '<div tooltip-trigger="showTooltip" class="tip-right bulb-form-error-message" '
        + `id="${attrs.id}-error">{{errorMessage}}</div>`;
      if (errorMessageAlignment.messagePosition === 'below') {
        errorMessageAbove = '';
        $errorMessageHTML = jQuery('<div class="bulb-form-error-message-override" '
          + `id="${attrs.id}-error">{{errorMessage}}</div>`);
        $compile($errorMessageHTML)(scope);
        $errorMessageHTML.hide();
        elem.after($errorMessageHTML);
      }

      $errorIconHTML = jQuery(`${errorMessageAbove}<div class="right" tooltip="{{errorMessage}}"`
        + `tooltip-trigger="showTooltip" tooltip-animation="false"><a class="${tooltipOptions.iconClass
        } right"><i class="fa fa-exclamation-circle error-icon" aria-hidden="true"></i></a></div>`);

      $compile($errorIconHTML)(scope);
      $errorIconHTML.hide();
      $errorIconHTML.hover(showTooltip, hideTooltip);
      elem.before($errorIconHTML);

      const toolTipError = $errorIconHTML.before();

      /**
       * Method for checking, whether text is truncated with ellipsis.
       * @returns {boolean} true, if truncated, false otherwise.
       */
      function isEllipsisActive() {
        const errMsgField = $(`#${attrs.id}-error`)[0];
        return (errMsgField && errMsgField.offsetWidth < errMsgField.scrollWidth);
      }

      /**
       * Method for setting message alignment and width.
       * @param fieldLabel - Label element of field.
       * @param fieldId - field id.
       */
      function updateErrorMessageProperties(fieldLabel, fieldId) {
        const errMsgField = $(`#${attrs.id}-error`)[0];
        if (errorMessageAlignment.messagePosition !== 'below') {
          if (fieldLabel) {
            const labelWidth = fieldLabel.width.split('px')[0];

            if (errorMessageAlignment.useClientWidth) {
              errMsgField.style.marginLeft = `${labelWidth}px`;
            }
          } else {
            errMsgField.style.position = 'relative';
          }
          errMsgField.style.textAlign = 'left';

          if (errorMessageAlignment.setMargin) {
            $timeout(() => {
              const lines = errMsgField.offsetHeight / parseInt(errMsgField.style.lineHeight);
              errMsgField.style.marginTop = `${-((lines === 1) ? 18 : lines * 15)}px`;
            });
          }
        } else {
          errMsgField.style.width = `${elem[0].clientWidth + 2}px`;
          errMsgField.style.textAlign = 'left';
        }

        // Override css properties of error message, if provided.
        if (errorMessageAlignment) {
          for (const property in errorMessageAlignment) {
            if (property === 'useClientWidth' && errorMessageAlignment[property]) {
              errMsgField.style.width = `${elem[0].clientWidth}px`;
            } else {
              errMsgField.style[property] = errorMessageAlignment[property];
            }
          }
        }
      }

      /**
       * Method for showing error message.
       * @param fieldLabel - Label element of field.
       * @param fieldId - field id.
       */
      function showErrorMessage(fieldLabel, fieldId) {
        updateErrorMessageProperties(fieldLabel, fieldId);
      }

      /**
       * Listener for the position change on the account in order to re-run the field validation on the form.
       */
      scope.$on('positionChange', () => {
        model.$validate();
      });

      /**
       * Set up the remote validation if there is any:
       *
       * We do not explicitly handle the situation where a value is being remotely validated and before a
       * response is received, a submit is attempted.  This is because if it turns out the validation fails,
       * the server will perform the same validation and the submit will fail, and the validation error will
       * be displayed just as if the submit had been delayed until the async validation was finished.
       *
       *   By default, pristine values are not validated via ajax validations.  However, if validation of pristine
       *   values is desired, the validatePristine option should be enabled, like this:
       *
       *   ... bulb-ajax-validation="{validator: 'emailUnique', validatePristine: true}" ...
       */
      if (attrs.bulbAjaxValidation) {
        let callback;
        let validatePristine = false;
        let validator = attrs.bulbAjaxValidation;
        const evalResult = scope.$eval(attrs.bulbAjaxValidation);
        if (evalResult) {
          validator = evalResult.validator;
          callback = evalResult.callback;
          validatePristine = evalResult.validatePristine;
        }
        model.$asyncValidators = elem.$asyncValidators || {};
        model.$asyncValidators[validator] = function (modelValue, viewValue) {
          const value = modelValue || viewValue;
          const deferred = $q.defer();
          if (model.$isEmpty(value) || (!validatePristine && model.$pristine)) {
            deferred.resolve();
          } else {
            BulbAjaxService.validateField(validator, value, attrs.bulbAjaxValidationOptions)
              .then((data) => {
                if (callback) {
                  callback(data);
                }
                if (!data.valid) {
                  model.errorCodes[validator] = data.code;
                  deferred.reject(data.code);
                } else {
                  delete model.errorCodes[validator];
                  deferred.resolve();
                }
              }, (error) => {
                model.errorCodes[validator] = 'validation_error_promo_code_does_not_match_position';
                deferred.reject('validation_error_promo_code_does_not_match_position');
              });
          }
          return deferred.promise;
        };
      }

      if (attrs.bulbValidationFieldMatch) {
        model.$validators.fieldMatch = function (modelValue, viewValue) {
          const details = scope.$eval(attrs.bulbValidationFieldMatch);
          model.errorCodes.fieldMatch = details.errorCode;
          const value = modelValue || viewValue;
          return value === details.field;
        };
        scope.$watch(attrs.bulbValidationFieldMatch, (value) => {
          model.$validate();
        });
      }

      if (attrs.bulbValidationCouponMatchesPeriod) {
        model.$validators.couponMatchesPeriod = function (modelValue, viewValue) {
          const period = scope.$eval(attrs.bulbValidationCouponMatchesPeriod);
          const value = (modelValue || viewValue);
          if (!value) {
            return true;
          }
          const firstChar = value.toUpperCase().charAt(0);
          if (firstChar === 'M' && period !== 'MONTH') {
            model.errorCodes.couponMatchesPeriod = 'account_billing_month_only_discount';
            return false;
          }
          if (firstChar === 'Y' && period !== 'YEAR') {
            model.errorCodes.couponMatchesPeriod = 'account_billing_year_only_discount';
            return false;
          }
          delete model.errorCodes.couponMatchesPeriod;
          return true;
        };
        scope.$watch(attrs.bulbValidationCouponMatchesPeriod, () => {
          model.$validate();
        });
      }

      // submitting create and update requests to the server may result in server validation errors.  This
      // handler allows server validation errors and server generated error messages to be displayed for all
      // validated fields.
      scope.$on('bulbRemoteValidationErrors', (event, args) => {
        if (args.fieldErrors[model.$name]) {
          model.$setValidity('remoteValidator', false);
          scope.remoteValidatorMessage = args.fieldErrors[model.$name];

          // add a listener to reset the validation error once a change has been made
          var resetRemoteValidator = function () {
            model.$setValidity('remoteValidator', true);
            delete scope.remoteValidatorMessage;

            // we only needed the listener once, so we can remove it now
            const index = model.$viewChangeListeners.indexOf(resetRemoteValidator);
            model.$viewChangeListeners.splice(index, 1);
          };
          model.$viewChangeListeners.push(resetRemoteValidator);
        }
      });

      /**
       * Show the validation tooltip, but arrange to hide the tooltip on click.
       * The tooltip, when it appears, is the very next element in the DOM after elem.
       */
      function showTooltip() {
        $timeout(() => {
          if (!isEllipsisActive()) {
            return;
          }
          toolTipError.trigger('showTooltip');
          scope.$evalAsync(() => {
            const tooltip = $errorIconHTML.next('.tooltip');
            let tooltipMinWidth = parseInt(getWidthOfText(tooltip[0].innerText));
            if (tooltipMinWidth >= 300) {
              tooltipMinWidth = 300;
              tooltip.css('text-align', 'right');
            } else {
              tooltip.css('text-align', 'center');
            }

            // constant for styling. This is how far from the top the bottom of the .tooltip > .nub needs to
            // be placed to get it to look like it's hovering over the error icon
            // wait for tooltip to render, so we get the tooltip width.
            $timeout(() => {
              tooltip.find('.nub').css('left', (tooltip[0]).offsetWidth - tooltipOptions.nubOffset);
            });

            tooltip.css('min-width', tooltipMinWidth);
            tooltip.css(
              'top',
              (parseInt(elem.position().top) - parseInt(tooltip.height()) - 2) * tooltipOptions.topPos,
            );
            tooltip.css('left', (attrs.id === 'username' || attrs.id === 'email')
              ? parseInt(tooltip.position().left) - tooltipMinWidth : 'auto');
            tooltip.css('right', attrs.id === 'username' ? null : 0);

            tooltip.addClass(tooltipOptions.tooltipClass);

            // override tooltip properties if provided.
            if (tooltipOptions.rightPos) {
              tooltip.css('right', `${tooltipOptions.rightPos}px`);
            }

            if (tooltip.length > 0) {
              tooltip.on('click', hideTooltip);
            }
          });
        });
      }

      /**
       * Hide the validation tooltip, but arrange to show it again if user clicks the input.
       */
      function hideTooltip() {
        $timeout(() => {
          toolTipError.trigger('hideTooltip');
          toolTipError.on('click', showTooltip);
        });
      }

      /**
       * Function to handle when an element is determined to be valid.
       */
      function setValid() {
        $errorIconHTML.hide();
        if ($errorMessageHTML) {
          $errorMessageHTML.hide();
        }
        elem.removeClass('bulb-invalid');
        elem.attr('aria-invalid', false);
        model.bulbInvalid = false;
        form.updateStatus(model.$name, true);
      }

      /**
       * Function to handle when an element is determined to be invalid.
       */
      function setInvalid() {
        $errorIconHTML.show();
        if ($errorMessageHTML) {
          $errorMessageHTML.show();
        }
        const label = (elem[0].labels[0]) ? getComputedStyle(elem[0].labels[0]) : null;
        showErrorMessage(label, attrs.id);
        elem.addClass('bulb-invalid');
        elem.attr('aria-invalid', true);
        model.bulbInvalid = true;
        form.updateStatus(model.$name, false);
      }

      // Watch for changes in state, and display/hide the tooltip and update the validation message as necessary.
      scope.$watchGroup(['model.$valid', 'model.$pristine', 'model.$touched'], () => {
        updateErrorMessage();
      });

      // Watch for error changes, so we can update the error message in case one reason for being invalid is
      // replaced by another.
      scope.$watchCollection('model.$error', () => {
        updateErrorMessage();
      });

      /**
       * Function to update the displayed validation status and error message for the element.
       */
      function updateErrorMessage() {
        // if the field is valid, we can simply make sure there is no error message and we are done.
        // fields that haven't been changed or touched and have no default value also don't show errors.
        // If initial validation is occuring, $valid may not yet be defined, so treat an undefined $valid as
        // being valid.
        if (typeof model.$valid === 'undefined'
          || model.$valid
          || (model.$pristine && !model.$touched && model.$isEmpty(model.$viewValue))) {
          // we don't have a default value, hide any validation messages
          scope.errorMessage = '';
          setValid();
        } else if (model.$error.remoteValidator) {
          scope.errorMessage = scope.remoteValidatorMessage;
          setInvalid();
        } else {
          let code = 'validation_error_standard';
          if (scope.errorCodeOverride) {
            code = scope.errorCodeOverride;
          }
          // DO LATER : extract this to a more standard area to handle all error message, or what?
          let args = {};
          if (model.$error.required) {
            code = 'validation_error_required';
          } else if (model.$error.pattern) {
            code = attrs.bulbMessageOverridePattern
              ? attrs.bulbMessageOverridePattern : 'validation_error_pattern';
          } else if (model.$error.email) {
            code = 'validation_error_email';
          } else if (model.$error.minlength) {
            code = 'validation_error_min_length';
            args = { value: attrs.minlength };
          } else if (model.$error.maxlength) {
            code = 'validation_error_max_length';
            args = { value: attrs.maxlength };
          } else {
            // Not a standard validation error, so check the failed validators to see if an error code
            // has been provided:
            angular.forEach(model.$error, (value, key) => {
              if (model.errorCodes[key]) {
                code = model.errorCodes[key];
              }
            });
          }
          $translate(code, args).then((translation) => {
            scope.errorMessage = translation;
            setInvalid();
          });
        }
      }

      // To make sure the length of the tooltip and wrapping looks good, we calculate how wide the text will be,
      // then set styles accordingly.
      function getWidthOfText(stringText) {
        const textWidthRep = jQuery(`<span class="tooltip-width-calculator" content="${
          stringText}">${stringText}</span>`);

        elem.before(textWidthRep);
        const textWidth = textWidthRep[0].clientWidth;
        textWidthRep.remove();

        return parseInt(textWidth) - 25;
      }
    },
  };
}
